export const B_Value = 1 // regularlyHeld
export const B2_Value = 2 // regularlyOccurring
export const B3_Value = 3 // regularlyHeldRestricted
export const B3C_Value = 4 // globallyMostImportant
export const D1a_Value = 5 // aggregationPredictability
export const D1b_Value = 6 // aggregationsAsCriteria
export const D2_Value = 7 // refugium
export const D3_Value = 8 // recruitmentSource

export const IBA_B1b_Value = 1 // ibaB1b
export const IBA_B2b_Value = 2 // ibaB2b
export const IBA_C2_Value = 3 // ibaC2
export const IBA_C3_Value = 4 // ibaC3
export const IBA_C6_Value = 5 // ibaC6

export const getIdCriteria = (item, arr) => {
  const result = []
  arr.forEach((itemArr) => {
    if (item[itemArr.fieldName]) {
      result.push(itemArr.value)
    }
  })
  return result
}

export const arrIdCriteria = [
  {
    fieldName: 'regularlyHeld',
    value: B_Value
  },
  {
    fieldName: 'regularlyOccurring',
    value: B2_Value
  },
  {
    fieldName: 'regularlyHeldRestricted',
    value: B3_Value
  },
  {
    fieldName: 'globallyMostImportant',
    value: B3C_Value
  },
  {
    fieldName: 'aggregationPredictability',
    value: D1a_Value
  },
  {
    fieldName: 'aggregationsAsCriteria',
    value: D1b_Value
  }, {
    fieldName: 'refugium',
    value: D2_Value
  },
  {
    fieldName: 'recruitmentSource',
    value: D3_Value
  }
]

export const arrIdIbaCriteria = [
  {
    fieldName: 'unfavourable',
    value: IBA_B1b_Value
  },
  {
    fieldName: 'concentrated',
    value: IBA_B2b_Value
  },
  {
    fieldName: 'annexListed',
    value: IBA_C2_Value
  },
  {
    fieldName: 'migratory',
    value: IBA_C3_Value
  },
  {
    fieldName: 'annexListedMi',
    value: IBA_C6_Value
  }
]
